module.exports = __webpack_public_path__ + "img/galeria-captores-9.fc2df460.png";